var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9.985 0c4.717 0 6.956.225 6.956.225s1.716.06 2.387 1.336c0 0 .67.925.67 5.439 0 0 .04 2.794-.277 4.28-.318 1.485-1.02 1.92-1.02 1.92s-.45.433-1.443.551c-.993.119-4.213.249-7.273.249 0 0-5.603-.003-7.49-.313C.61 13.377.344 11.628.344 11.628s-.772-4.429 0-9.251c0 0 .224-1.926 2.479-2.152 0 0 2.445-.225 7.163-.225zm3.422 6.89L7.912 4.157v5.469l5.495-2.734z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgYoutube;